import Home from "./container/servicoEmpresa.home";

const routes = [
  {
    name: "servicoEmpresa",
    path: "/servicoEmpresa",
    component: Home,
    breadCrumb: [{ text: "Serviços Empresas" }]
  }
];

export default routes;
